export const calculateAnalogFixed = {
    calculateFixEconomicClassifications,
    calculateFixOwnerShipRights,
    calculateFixSalesDate,
    calculateFixEngineerCommunication,
    calculateFixFloor,
    calculateFixAutoTransportPlaceCloseness,
    calculateFixConstructiveElements,
    calculateFixRepairConditions,
    calculateFixAdvertisementDatePicked,
    calculateFixAfterSale,
    calculateFixPhysicalCharacteristics,
    calculateFixMadeYear,
    calculateFixRailwayAndElevator
};

function calculateFixEconomicClassifications(compValue, analogValue) {
    if (compValue === 'high' && analogValue === 'middle') {
        return 5;
    } else if (compValue === 'middle' && analogValue === 'high') {
        return -5;
    } else if (compValue === 'high' && analogValue === 'low') {
        return 10;
    } else if (compValue === 'low' && analogValue === 'high') {
        return -10;
    } else if (compValue === 'middle' && analogValue === 'low') {
        return 5;
    } else if (compValue === 'low' && analogValue === 'middle') {
        return -5;
    } else return 0;
}

function calculateFixPhysicalCharacteristics(compValue, analogValue) {
    if (compValue === 'high' && analogValue === 'middle') {
        return 5;
    } else if (compValue === 'middle' && analogValue === 'high') {
        return -5;
    } else if (compValue === 'high' && analogValue === 'low') {
        return 10;
    } else if (compValue === 'low' && analogValue === 'high') {
        return -10;
    } else if (compValue === 'middle' && analogValue === 'low') {
        return 5;
    } else if (compValue === 'low' && analogValue === 'middle') {
        return -5;
    } else return 0;
}

function calculateFixOwnerShipRights(compOwnershipRight, analogOwnershipRight) {

    if ((compOwnershipRight === 'permanent') && (analogOwnershipRight === 'temporary_use')) {
        return 5;
    } else if ((compOwnershipRight === 'temporary_use') && (analogOwnershipRight === 'permanent')) {
        return -5;
    } else if ((compOwnershipRight === 'permanent') && (analogOwnershipRight === 'rental_agreement')) {
        return 10;
    } else if ((compOwnershipRight === 'rental_agreement') && (analogOwnershipRight === 'permanent')) {
        return -10;
    } else if ((compOwnershipRight === 'temporary_use') && (analogOwnershipRight === 'rental_agreement')) {
        return 5;
    } else if ((compOwnershipRight === 'rental_agreement') && (analogOwnershipRight === 'temporary_use')) {
        return -5;
    } else return 0;
}

function calculateFixSalesDate(analogValue, createDate) {

    createDate = createDate.split(' ');
    let date = createDate[0].split(/\//);
    let time = createDate[1];

    let newDate = date[1] + '/' + date[0] + '/' + date[2] + ' ' + time;

    let diff = (new Date(newDate).getTime() - analogValue.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7 * 4);

    const diffMonth = Math.abs(Math.round(diff));

    if (diffMonth <= 1) {
        return 0;
    } else if (diffMonth <= 2) {
        return 5;
    } else if (diffMonth <= 3) {
        return 10;
    } else return 15;
}

function calculateFixEngineerCommunication(compEngineerCommunication, analogEngineerCommunication) {

    if (compEngineerCommunication === 'all' && analogEngineerCommunication === 'some') {
        return 5;
    } else if (compEngineerCommunication === 'some' && analogEngineerCommunication === 'all') {
        return -5;
    } else if (compEngineerCommunication === 'all' && analogEngineerCommunication === 'non_exists') {
        return 10;
    } else if (compEngineerCommunication === 'non_exists' && analogEngineerCommunication === 'all') {
        return -10;
    } else if (compEngineerCommunication === 'some' && analogEngineerCommunication === 'non_exists') {
        return 5;
    } else if (compEngineerCommunication === 'non_exists' && analogEngineerCommunication === 'some') {
        return -5;
    } else return 0;
}

function calculateFixFloor(compFloor, analogFloor) {

    if (analogFloor > 0) {
        if (analogFloor - compFloor > 0 && analogFloor - compFloor <= 1) {
            return -5
        } else if (compFloor - analogFloor > 0 && compFloor - analogFloor <= 1) {
            return 5
        }
        if (analogFloor - compFloor > 1 && analogFloor - compFloor <= 2) {
            return -10
        } else if (compFloor - analogFloor > 1 && compFloor - analogFloor <= 2) {
            return 10
        } else if (analogFloor - compFloor >= 3) {
            return -15
        } else if (compFloor - analogFloor >= 3) {
            return 15
        } else return 0
    } else return 0
}

function calculateFixAutoTransportPlaceCloseness(compValue, analogValue) {

    if (compValue === 'high' && analogValue === 'middle') {
        return 5;
    } else if (compValue === 'middle' && analogValue === 'high') {
        return -5;
    } else if (compValue === 'high' && analogValue === 'low') {
        return 10;
    } else if (compValue === 'low' && analogValue === 'high') {
        return -10;
    } else if (compValue === 'middle' && analogValue === 'low') {
        return 5;
    } else if (compValue === 'low' && analogValue === 'middle') {
        return -5;
    } else return 0;
}

function calculateFixConstructiveElements(compValue, analogValue) {

    if (compValue === 'brick_baked' && analogValue === 'panel_concrete') {
        return 5;
    } else if (compValue === 'panel_concrete' && analogValue === 'brick_baked') {
        return -5;
    } else if (compValue === 'brick_baked' && analogValue === 'brick_crude') {
        return 10;
    } else if (compValue === 'brick_crude' && analogValue === 'brick_baked') {
        return -10;
    } else if (compValue === 'panel_concrete' && analogValue === 'brick_crude') {
        return 5;
    } else if (compValue === 'brick_crude' && analogValue === 'panel_concrete') {
        return -5;
    } else return 0;
}

function calculateFixRepairConditions(compValue, analogValue) {

    if (compValue === 'good' && analogValue === 'excellent') {
        return 5;
    } else if (compValue === 'excellent' && analogValue === 'good') {
        return -5;
    } else if (compValue === 'good' && analogValue === 'bad') {
        return 10;
    } else if (compValue === 'bad' && analogValue === 'good') {
        return -10;
    } else if (compValue === 'excellent' && analogValue === 'bad') {
        return 5;
    } else if (compValue === 'bad' && analogValue === 'excellent') {
        return -5;
    } else return 0;
}

function calculateFixAdvertisementDatePicked(createDate, analogValue) {
    createDate = createDate.split(' ');
    let date = createDate[0].split(/\//);
    let time = createDate[1];

    let newDate = date[1] + '/' + date[0] + '/' + date[2] + ' ' + time;
    let diff = (new Date(newDate).getTime() - analogValue.getTime()) / 1000;
    diff /= (60 * 60 * 24 * 7 * 4);

    const diffMonth = Math.abs(Math.round(diff));

    if (diffMonth <= 1) {
        return 0;
    } else if (diffMonth >= 1) {
        return 5;
    }
}

function calculateFixAfterSale(compAfterSale, analogAfterSale) {
    if (compAfterSale === 'exists' && analogAfterSale === 'non_exists') {
        return -5;
    }else if (compAfterSale === 'non_exists' && analogAfterSale === 'exists') {
        return 5;
    }else return 0;
}

function calculateFixMadeYear(compValue,analogValue) {
    if ((analogValue - compValue >= 3) && (Math.abs(analogValue - compValue) <= 10)) {
        return -5;
    } else if ((compValue - analogValue >= 3) && (compValue - analogValue <= 10)) {
        return 5;
    } else if (analogValue - compValue >= 11 && analogValue - compValue <= 15) {
        return -10;
    } else if (compValue - analogValue >= 11 && compValue - analogValue <= 15) {
        return 10;
    } else if (analogValue - compValue >= 16 && analogValue - compValue <= 20) {
        return -15;
    } else if (compValue - analogValue >= 16 && compValue - analogValue <= 20) {
        return 15
    } else if (analogValue - compValue > 20) {
        return -20
    } else if (compValue - analogValue > 20) {
        return 20
    } else return 0.000;
}

function calculateFixRailwayAndElevator(compValue,analogValue) {
    if (compValue === 'exists' && analogValue === 'non_exists') {
        return 5;
    }else if (compValue === 'non_exists' && analogValue === 'exists') {
        return -5;
    }else return 0;
}